import React, { useState, useEffect } from 'react';
import { ChevronDown, Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { navLinks } from '../mock';
import BLKLogo from './BLKLogo';

const Header = ({ onGetStarted, onSignIn }) => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? 'bg-[#05050a]/90 backdrop-blur-xl border-b border-white/5' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-6 lg:px-8 h-[72px] flex items-center justify-between">
        <BLKLogo />

        <nav className="hidden lg:flex items-center gap-7">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="text-[13.5px] text-gray-300 hover:text-white transition-colors duration-200 flex items-center gap-1"
            >
              {link.label}
              {link.hasDropdown && <ChevronDown className="w-3.5 h-3.5 opacity-70" />}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Button
            onClick={onGetStarted}
            data-testid="header-get-started-btn"
            className="h-9 px-5 rounded-md text-sm font-medium bg-gradient-to-r from-[#7c3aed] to-[#4f46e5] hover:from-[#8b45f0] hover:to-[#5b52ee] text-white shadow-[0_0_20px_rgba(124,58,237,0.35)] border-0"
          >
            Get Started
          </Button>
        </div>

        <button
          className="lg:hidden text-white p-2"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {mobileOpen && (
        <div className="lg:hidden bg-[#0a0a12] border-t border-white/5" data-testid="mobile-menu">
          <nav className="flex flex-col p-6 gap-4">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-sm text-gray-300 hover:text-white"
                onClick={() => setMobileOpen(false)}
              >
                {link.label}
              </a>
            ))}
            <div className="flex flex-col gap-2 pt-3 border-t border-white/5">
              <Button onClick={() => { setMobileOpen(false); onGetStarted(); }} data-testid="mobile-get-started-btn" className="h-10 rounded-md text-sm bg-gradient-to-r from-[#7c3aed] to-[#4f46e5] text-white border-0">
                Get Started
              </Button>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
